import * as actionTypes from './actionTypes';

const initialState = {
  // Flat array of all folder ids for each space id
  folderIdsBySpaceId: {},

  // Parsed tree of all folders for each space id
  // Each tree node contains a reduced representation of folders containing only the id and name
  folderTreeBySpaceId: {},

  // Array of space ids that are currently loading the folder tree
  spaceIdsLoadingFolderTree: [],

  // active folder in the folder tree
  activeFolderId: null,

  // subfolders of the active folder
  activeFolderChildrenIds: [],

  activeFolderChildrenIsLoading: false,

  // folder being currently edited
  editingFolderId: null,

  documentCountByFolderId: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_FOLDER_TREE:
      return {
        ...state,
        folderTreeBySpaceId: {
          ...state.folderTreeBySpaceId,
          [action.spaceId]: action.folderTree,
        },
      };

    case actionTypes.SET_ACTIVE_FOLDER_ID:
      return {
        ...state,
        activeFolderId: parseInt(action.id, 10) || null,
      };

    case actionTypes.SET_EDITING_FOLDER_ID:
      return {
        ...state,
        editingFolderId: parseInt(action.id, 10),
      };

    case actionTypes.FETCH_FOLDER_TREE:
      return {
        ...state,
        spaceIdsLoadingFolderTree: [
          ...state.spaceIdsLoadingFolderTree,
          // only show loader on initial load, not on updates
          ...(state.folderTreeBySpaceId[action.spaceId] ? [] : [action.spaceId]),
        ],
      };

    case actionTypes.FETCH_FOLDER_TREE_SUCCESS:
      return {
        ...state,
        ids: action.ids,
        folderIdsBySpaceId: {
          ...state.folderIdsBySpaceId,
          [action.spaceId]: action.ids,
        },
        folderTreeBySpaceId: {
          ...state.folderTreeBySpaceId,
          [action.spaceId]: action.folderTree,
        },
        spaceIdsLoadingFolderTree:
            state.spaceIdsLoadingFolderTree.filter((id) => id !== action.spaceId),
      };

    case actionTypes.FETCH_CHILDREN:
      return {
        ...state,
        activeFolderChildrenIsLoading: true,
      };
    case actionTypes.FETCH_CHILDREN_SUCCESS:
      return {
        ...state,
        activeFolderChildrenIsLoading: false,
        activeFolderChildrenIds: action.ids.map((id) => parseInt(id, 10)),
      };

    case actionTypes.CREATE_SUCCESS:
      return {
        ...state,
        activeFolderChildrenIds: [action.id, ...state.activeFolderChildrenIds],
      };

    case actionTypes.CREATE_MULTIPLE_SUCCESS:
      return {
        ...state,
        activeFolderChildrenIds: [...action.ids, ...state.activeFolderChildrenIds],
      };

    case actionTypes.DELETE_SUCCESS:
      return {
        ...state,
        activeFolderChildrenIds:
            state.activeFolderChildrenIds.filter((id) => id !== action.id),
      };

    case actionTypes.FETCH_FOLDER_DOCUMENT_COUNT_SUCCESS:
      return {
        ...state,
        documentCountByFolderId: {
          ...state.documentCountByFolderId,
          ...action.documentCountByFolderId,
        },
      };

    default:
      return state;
  }
};
